import { hexToRgba } from '../../../../utils/lightenColor';

export default hexToRgba;
